const PREFS_KEY = 'beezy-notification-prefs';

const DEFAULT_PREFS = {
  enabled: false,
  threshold: 30,
  intervalMinutes: 15,
};

export const getNotificationPrefs = () => {
  try {
    const stored = localStorage.getItem(PREFS_KEY);
    return stored ? { ...DEFAULT_PREFS, ...JSON.parse(stored) } : { ...DEFAULT_PREFS };
  } catch {
    return { ...DEFAULT_PREFS };
  }
};

export const setNotificationPrefs = (prefs) => {
  localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
};

export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    return 'denied';
  }
  if (Notification.permission === 'granted') {
    return 'granted';
  }
  return Notification.requestPermission();
};

export const showNotification = async (title, options = {}) => {
  if (Notification.permission !== 'granted') return;

  try {
    const registration = await navigator.serviceWorker?.ready;
    if (registration) {
      registration.showNotification(title, {
        icon: '/logo192.png',
        badge: '/logo192.png',
        ...options,
      });
    }
  } catch {
    // Fallback to regular notification if SW unavailable
    new Notification(title, options);
  }
};
